import { BaseService } from "@/script/core/service/BaseService";
import { Failure, Success } from "@/script/core/service/DataService";
import { AppUser } from "../entity/UserEntity";

export class AppUserService extends BaseService {
    public setLargeDiscount(user: AppUser, success: Success, failure: Failure) {
        super.postReturnResponse("/api/user/appuser/large/discount/set", user).then(
          function(response) {        
            success(response);
          },
          function(error: Error) {
            failure(error);
          }
        );
      }
}
